// assets/cart-note.js
(function () {
  var SAVE_DEBOUNCE = 300;

  function getUpdateUrl() {
    try {
      if (window.Theme?.routes?.cart_update_url) return window.Theme.routes.cart_update_url;
      if (window.routes?.cart_update_url) return window.routes.cart_update_url;
    } catch (e) {}
    return '/cart/update.js';
  }

  function saveNote(value, signal) {
    return fetch(getUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: value || '' }),
      signal: signal
    }).then(function () {
      // Let the theme refresh totals/badges if it listens for this
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function(){});
  }

  function ensureFormAttr(el) {
    if (el.getAttribute('form')) return;
    // Find the main cart form so the note also submits with Checkout
    var form = document.querySelector('form[action="/cart"]') || document.querySelector('form[id*="cart"]');
    if (form) {
      if (!form.id) form.id = 'cart-form';
      el.setAttribute('form', form.id);
    }
  }

  function bindNote(el) {
    if (!el || el.dataset.bound) return;
    el.dataset.bound = '1';
    ensureFormAttr(el);

    var controller = null;
    var timer = null;

    function flush() {
      if (controller) controller.abort();
      controller = new AbortController();
      saveNote(el.value, controller.signal).finally(function(){ controller = null; });
    }

    el.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(flush, SAVE_DEBOUNCE);
    });
    el.addEventListener('blur', flush);
  }

  // (Optional) Also auto-save cart attributes like attributes[Delivery date]
  function saveAttribute(key, value, signal) {
    var payload = { attributes: {} };
    payload.attributes[key] = value || '';
    return fetch(getUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: signal
    }).catch(function(){});
  }
  function bindAttribute(el) {
    if (!el || el.dataset.bound) return;
    var m = el.name && el.name.match(/^attributes\[(.*)\]$/);
    if (!m) return;
    el.dataset.bound = '1';

    var controller = null;
    var t = null;
    function flush() {
      if (controller) controller.abort();
      controller = new AbortController();
      saveAttribute(m[1], el.value, controller.signal).finally(function(){ controller = null; });
    }

    el.addEventListener('change', flush);
    el.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(flush, 400);
    });
    el.addEventListener('blur', flush);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('textarea[name="note"]').forEach(bindNote);
    (scope || document).querySelectorAll('[name^="attributes["]').forEach(bindAttribute); // optional, safe to keep
  }

  // Initial bind + Shopify section events
  document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  document.addEventListener('shopify:section:select', function(e){ scan(e.target); });

  // Catch drawer/AJAX insertions
  var obs = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(node){
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('textarea[name="note"], [name^="attributes["]')) {
          if (node.name === 'note' || node.getAttribute('name') === 'note') bindNote(node);
          else bindAttribute(node);
        } else {
          scan(node);
        }
      });
    });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
